import * as Portal from '@radix-ui/react-portal';
import { ReactNode, useEffect, useState } from 'react';

type Props = {
  elementId: string;
  children: ReactNode;
};

// @deprecated Use tunnelrat instead
export const Slot = ({ elementId, children }: Props) => {
  const [, forceRerender] = useState(false);
  useEffect(() => {
    if (document.getElementById(elementId)) {
      forceRerender(true);
    }
  });
  // ssr pages need to check for undefined document first
  if (typeof document === 'undefined') {
    return null;
  } else {
    return (
      <Portal.Root container={document.getElementById(elementId)}>
        {children}
      </Portal.Root>
    );
  }
};

export default Slot;
